import { render, staticRenderFns } from "./StakingOverview.vue?vue&type=template&id=57821f46&scoped=true&"
import script from "./StakingOverview.vue?vue&type=script&lang=ts&"
export * from "./StakingOverview.vue?vue&type=script&lang=ts&"
import style0 from "./StakingOverview.vue?vue&type=style&index=0&id=57821f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57821f46",
  null
  
)

export default component.exports